import { UsersService } from "./lib/services/users-service";

export * from "./lib/users-service-types";
export { authContext, AuthProvider } from "./lib/providers/auth-provider";
export { propertiesContext, PropertiesProvider } from "./lib/providers/properties-provider";
export { useUserInfo } from "./lib/hooks/useUserInfo";
export { UserSearchSelect, renderAvatar, renderGroupIcon } from "./ui/user-search-select/user-search-select"
export { StaffCard } from "./ui/staff-card/staff-card"
export { hasPermission } from "./lib/const/permissions";
export type { IPermissions } from "./lib/const/permissions";
export { usePermission } from "./lib/hooks/usePermission";

export const userService = new UsersService();
